import { render, staticRenderFns } from "./SalarySchemeEdit.vue?vue&type=template&id=4c6047b7&"
import script from "./SalarySchemeEdit.vue?vue&type=script&lang=js&"
export * from "./SalarySchemeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports